import React, { Component } from 'react';
import ChatWindow from './chat-window.js';

class App extends Component {
  render() {
    return (
      <div>
        {/* <ChatWindow /> */}
      </div>
    );
  }
}

export default App;



// command-k-c: comment block
// command-k-u: uncomment